<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppdrop005#toc">Dedication</a></p>
<p class="ded">As always, to Butch.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-drop004.vue?47c85f70